import { Map } from "utilities/types/map";
import { TranslatedCopy } from "utilities/interfaces/culture-resources";

// -------------------------------------------------------------------------------------------------
// #region Enum
// -------------------------------------------------------------------------------------------------

enum AddBulkGroupUsersModalStage {
    Complete = 0,
    Errored = 1,
    Processing = 2,
    Upload = 3,
    Preview = 4,
}

// #endregion Enum

// -------------------------------------------------------------------------------------------------
// #region Maps
// -------------------------------------------------------------------------------------------------

const AddBulkGroupUsersModalStageStatusMap: Map<AddBulkGroupUsersModalStage, TranslatedCopy> = {
    [AddBulkGroupUsersModalStage.Complete]: "complete",
    [AddBulkGroupUsersModalStage.Errored]: "error",
    [AddBulkGroupUsersModalStage.Processing]: "processing",
    [AddBulkGroupUsersModalStage.Upload]: "emptyString",
    [AddBulkGroupUsersModalStage.Preview]: "preview",
};

// #endregion Maps

// -------------------------------------------------------------------------------------------------
// #region Exports
// -------------------------------------------------------------------------------------------------

export { AddBulkGroupUsersModalStage, AddBulkGroupUsersModalStageStatusMap };

// #endregion Exports
